export default __webpack_public_path__ + "static/media/curseball.2ad04699.png";